export interface NotificationModel {
  id: string;
  fileIdentifier: string;
  videoLink?: string | null;
  audioLink?: string | null;
  message?: string | null;
  originalLang? : string | null;
  targetLang? : string | null;
  type: string;
  seen: boolean | false;
  createdAt: Date;
  requestId?: string | null;
  relatedRequestId?: string | null;
  fileName?: string | null;
  status: NotificationStatus;
  /** True when this is an ONETIME_AUDIO_UPLOAD and the user already uploaded (notification is no longer actionable). */
  uploadAlreadyUsed?: boolean;
  /** True when the user uploaded a file from this one-time upload notification. */
  consumed?: boolean;
  /** For ONETIME_AUDIO_UPLOAD: "youtube" | "video" | "audio" — used to route to the correct screen. */
  orderSourceType?: string | null;
}

export enum NotificationStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED"
}